module.exports = __webpack_public_path__ + "Flag-798.e8b3ff4d0bba94d3fee0e4dc54f81390.svg";